import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
`;

const AdminUsers: React.FC = () => {
  return (
    <Container>
      <Title>Users Management</Title>
      <p>This page is under construction.</p>
    </Container>
  );
};

export default AdminUsers; 